import posthog from 'posthog-js';

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;

if (posthogKey) {
  posthog.init(posthogKey, {
    api_host: 'https://app.posthog.com',
    capture_pageview: false, // We'll manually capture
    capture_pageleave: true,
  });
}

export const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
  if (posthogKey) {
    posthog.capture(eventName, properties);
  }
};

export const identifyUser = (email: string) => {
  if (posthogKey) {
    posthog.identify(email);
  }
};
